var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.saveKey)?_c('saveData',{key:_vm.saveKey,attrs:{"onClose":(id) => {
        _vm.onClose(id)
      },"save":_vm.save,"editID":_vm.editID}}):_vm._e(),_c('div',{ref:"pagebuilder"},[_c('b-flix-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }